import React from 'react';

import Principle from './principle';

import config from '../../../../config/config';

import './perform-audit.scss';

/**
 * Parent component enabling a user to perform audits through it's children
 */
const RightPanel = () => {
  // LOCAL STATE

  return (
    <div className='perform-audit'>
      <p className='perform-audit__title'>FSC Principles and Criteria</p>
      <p className='perform-audit__subtitle'>The charts below show the amount of tree cover loss falling within the selected geometry that intersects the audit area. These values only consider the Tree Cover Loss data.</p>
      <div className='perform-audit__principles'>
        {config.audit.principles.map((principleObj, key) => (
          <Principle key={key} principleObj={principleObj} />
        ))}
      </div>
    </div>
  );
};

export default RightPanel;
